import axios from "axios";
import interceptors from "./interceptors.js"; // eslint-disable-line no-unused-vars

const config = {
  baseUrl: process.env.VUE_APP_PLAN_API_BASE,
};


function deleteStudyPlan(planId) {
  
  return axios.delete(`${config.baseUrl}/study/plan`, {
    params: {
      studyPlanId: planId
    },
    withCredentials: true
  });
}

function fetchStudyPlan(payload) {
  
  return axios.get(`${config.baseUrl}/study/plan/detail`, {
    params: {
      frlProgressCd: payload.progress,
    },
    withCredentials: true
  });
}

function submitPlanPreview(payload) {
  return axios.get(`${config.baseUrl}/survey/submit`, {
    params: {
      frlProgressCd: payload.progress, 
      acmltSurveyAnsItmId: payload.acmltSurveyAnsItmId,
    },
    withCredentials: true
  });
}

function fetchPlanPreviewResult(payload) {
  return axios.get(`${config.baseUrl}/survey/result/prevw`, {
    params: {
      frlProgressCd: payload.progress, 
      acmltSurveyAnsItmId: payload.acmltSurveyAnsItmId,
    },
    withCredentials: true
  });
}

export { fetchStudyPlan, fetchPlanPreviewResult, submitPlanPreview, deleteStudyPlan };
